import { TranslationObject } from '../i18n/translation';

const namespace = 'vurderinger';
const translations: TranslationObject = {
  praksisaktivitet: {
    id: `${namespace}.praksisaktivitet`,
    nb: 'Praksisaktivitet',
    en: 'Practice activity',
  },
  periode: {
    id: `${namespace}.periode`,
    nb: 'Periode',
    en: 'Period',
  },
  praksisklasse: {
    id: `${namespace}.praksisklasse`,
    nb: 'Praksisklasse',
    en: 'Practice class',
  },
  studenter: {
    id: `${namespace}.studenter`,
    nb: 'Studenter',
    en: 'Students',
  },
  status: {
    id: `${namespace}.status`,
    nb: 'Status',
    en: 'Status',
  },
  handling: {
    id: `${namespace}.handling`,
    nb: 'Handling',
    en: 'Action',
  },
  activitySectionTitle: {
    id: `${namespace}.activitySectionTitle`,
    nb: 'Praksisaktiviteter',
    en: 'Practice activities',
  },
  title: {
    id: `${namespace}.title`,
    nb: 'Velg praksisaktivitet for vurdering',
    en: 'Select practice activity for evaluation',
  },
  subtitle: {
    id: `${namespace}.subtitle`,
    nb: 'For å se vurdering for en praksisaktivitet, må du velge en aktivitet i tabellen.',
    en: 'To see the evaluation for a practice activity, select an activity in the table.',
  },
  handlingButton: {
    id: `${namespace}.handlingButton`,
    nb: 'Gå til vurdering',
    en: 'Go to evaluation',
  },
  emptyStateTitle: {
    id: `${namespace}.emptyStateTitle`,
    nb: 'Du deltar ikke i noen praksisaktiviteter som benytter vurdering.',
    en: 'You do not participate in any activities that use evaluation.',
  },
  emptyStateText: {
    id: `${namespace}.emptyStateText`,
    nb: 'Hvis du forventer å finne aktiviteter her, påse at du deltar i dem og at de benytter vurdering.',
    en: 'If you expect to find activities here, ensure that you participate in them and that they use evaluation.',
  },
  statusFramtidig: {
    id: `${namespace}.statusFramtidig`,
    nb: 'Ikke påbegynt',
    en: 'Not started',
  },
  statusAktiv: {
    id: `${namespace}.statusAktiv`,
    nb: 'Aktiv praksis',
    en: 'Active practice',
  },
  statusGjennomfoert: {
    id: `${namespace}.statusGjennomfoert`,
    nb: 'Gjennomført praksis',
    en: 'Completed practice',
  },
};
export default translations;
